/*
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2022-02-08 18:36:51
 * @LastEditors: shenlin
 * @LastEditTime: 2022-02-08 18:56:49
 */
const BASE_URL = '/lishui-gov'
import request from '@/common/api/request'
// 诉求列表
export const appealList = params =>
  request.get(BASE_URL + '/entAppeal/appealList', { params })
// 诉求处理
export const handleAppeal = params =>
  request.post(BASE_URL + '/entAppeal/handleAppeal', params)
// 诉求详情
export const appealDetail = params =>
  request.get(BASE_URL + '/entAppeal/appealDetail', { params })
// 删除诉求
export const deleteAppeal = params =>
  request.get(BASE_URL + '/entAppeal/deleteAppeal', { params })
// 诉求导出
export const appealExport = params =>
  request.downLoad(BASE_URL + '/entAppeal/appealExport', { params })

// 诉求看板
export const statisticsAnalysis = params =>
  request.get(BASE_URL + '/entAppeal/statisticsAnalysis', { params })

// 区县诉求排行榜
export const areaSort = params =>
  request.get(BASE_URL + '/entAppeal/areaSort', { params })
